import {BaseIsbnApplication} from "../../../../shared/base/contituents/isbn-application/models/BaseIsbnApplication";

export class IsbnApplication extends  BaseIsbnApplication {
}
